import React from 'react';

// import Responsive from '../../Responsive';





export default class Schedule extends React.Component {
    state = {
        showTree: false,
        second: false,
        days: [
            { day: "Sun", date: "25", img: "", },
            { day: "Mon", date: "24", img: "", },
            { day: "Tue", date: "23", img: "", },
            { day: "Wed", date: "22", img: "", },
            { day: "Thu", date: "21", img: "", },
            { day: "Fri", date: "20", img: "", },
            { day: "Sat", date: "19", img: "", },
        ],
        title: [
            { day: "Sun", date: "25", img: "", },
            { day: "Mon", date: "24", img: "", },
            { day: "Tue", date: "23", img: "", },
            { day: "Wed", date: "22", img: "", },
            { day: "Thu", date: "21", img: "", },
            { day: "Fri", date: "20", img: "", },
            { day: "Sat", date: "19", img: "", },
        ],

        users: [
            { name: "poya pezhman", img: "/images/person-img-1.png" },
            { name: "nastaran javid", img: "/images/person-img-2.png" },
            { name: "mohrechi", img: "/images/person-img-3.png" },
            { name: "salarvand", img: "/images/person-img-4.png" },
            { name: "poya pezhman", img: "/images/person-img-1.png" },
            { name: "nastaran javid", img: "/images/person-img-2.png" },
            { name: "mohrechi", img: "/images/person-img-3.png" },
            { name: "salarvand", img: "/images/person-img-4.png" },
            { name: "poya pezhman", img: "/images/person-img-1.png" },
            { name: "nastaran javid", img: "/images/person-img-3.png" },
            { name: "mohrechi", img: "/images/person-img-1.png" },
            { name: "salarvand", img: "/images/person-img-1.png" },
            // { title: "(empty)", },
            // { title: "Username", },
            // { title: "Username", },
        ],

        data: [
            { name: "Task number 1", priority: 'hight' },
            { name: "Task number 1", priority: 'hight' },
        ],



    }
    // setNewTask = () => {

    //     // console.log("setnewtask", this.state.newTask)
    //     this.setState({ newTask: !this.state.newTask })

    showTree = (index) => {
        let isOpen = this.state.isOpen
        // isOpen = {}
        isOpen[index] = !isOpen[index]

        this.setState({ isOpen });

        console.log("fist", this.state.isOpen)
    }
    second = () => {
        this.setState({ showSecond: !this.state.showSecond });
        // console.log("fist")
    }
    render() {

        return (
            <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar'>
                <div className='w-100 sc-4 mt-2' style={{ overflowX: "scroll" }}>
                    <div className='d-flex'>
                        <div className='pld-3 position-sticky bg-white' style={{ marginTop: "87.5px", minWidth: "150px", left: 0, zIndex: "10" }}>
                            {this.state.users.map((prop, index) => {
                                return (
                                    <div className='flexc costomize-border' style={{ minHeight: "80px", }}>
                                        <div className='flexc h-100 '>
                                            <img className='br-50 mrd-3' style={{ width: "30px" }} src={prop.img} />
                                        </div>
                                        <div className=''>
                                            <p className='font-size-12 nowrap'>{prop.name}</p>

                                            <div className='flexc'>
                                                <img className='ws-15 mrd-2 pld-1' src='/images/icons/clock.png' />
                                                <p className='font-size-12 gray-600' >00:00</p>

                                            </div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                        {this.state.title.map((prop, index) => {
                            return (
                                <div className=''>
                                    <div className='mt-2 position-sticky ' style={{ minWidth: "150px", border: "1px solid #dedede", top: 0, background: "#fff", zIndex: "10", minHeight: "80px" }}>
                                        <button className=' br-20 px-3 pt-3' style={{}}>
                                            <p className=' font-size-12 weight-300'>{prop.day}</p>
                                            <p className='gray-600 font-size-20 weight-500 mld-2'>{prop.date}</p>
                                        </button>
                                    </div>
                                    <div className=''>
                                        {this.state.users.map((prop, index) => {
                                            return (
                                                <div className=' p-3 w-100 position-relative' style={{ minWidth: "150px", minHeight: "80px", border: "1px solid #efefef" }}>

                                                    {/* <button className='position-absolute br-10' style={{ bottom: 10, right: 10, backgroundColor: "#eee" }}>
                                                        <img className='flexcc' src='/assets/icons/plus-blue.svg' />
                                                    </button> */}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        })}
                    </div>


                </div>
            </div>
        )
    }
}
